<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/equipment/equipment-list' }">设备管理</el-breadcrumb-item>
          <el-breadcrumb-item >设备修改</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12 style="padding: 5px 0px;">
        <div style="padding:1px 6px 0px 6px">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">修改设备信息</div>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form">
            <!-- <el-form-item label="用户名">
                  <label for="username">用户名：</label>
                  <el-input id="username" v-model="form.username"></el-input>
                </el-form-item> -->
            <el-form-item label="设备UDI" prop="equip_udi" style="margin-top: 36px;" class="error">

              <el-input id="equip_udi" v-model="form.equip_udi" placeholder="请输入49位完整UDI">
              </el-input>
            </el-form-item>
            <el-form-item label="使用单位" prop="hospital_name">
              <el-input id="hospital_name" v-model="form.hospital_name" placeholder="" ></el-input>
            </el-form-item>
            <el-form-item label="所在地区" prop="provinceName">
              <el-input id="provinceName" v-model="form.provinceName"  :readonly="true" style="width: 200px;"></el-input>
              <el-input id="cityName" v-model="form.cityName" :readonly="true" style="width: 200px;margin-left: 5px;"></el-input>
              <!-- <el-button class="warning-handle" @click="resetForm()" size='mini'>重置</el-button> -->
              <el-cascader
              id="mycascader"
              placeholder="请选择使用单位所在地区"
              :options="placeList"
              :props="{ value: 'id',label: 'name'}"
              @change="getSelectedList"
              style="width: 300px;margin-top: 5px;"
              ></el-cascader>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="action-button" @click="submitForm('form')">立即保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </dv-border-box-12>
    </div>
  </div>
</template>

<script>
  import {areaSingleConversionUtil} from '../../../utils/povince_handle.js'

  export default {
    data() {
      return {
        form: {
          id:'',
          equip_udi: '',
          hospital_name: '',
          provinceCode:'',
          provinceName:'',
          cityCode:'',
          cityName:'',
        },
        rules: {
          equip_udi: [{ required: true, message: '请填写设备UDI', trigger: 'blur'},{min: 49,max:49,message:'请输入49位完整UDI'}],
          // hospital_name: [{ required: true, message: '请填写使用单位', trigger: 'blur' }],
          // provinceCode: [{ required: true, message: '请选择使用单位所在地', trigger: 'blur' }],
        },
        placeList:[],
      }
    },
    methods: {

      getEquipDetail(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/detail';
        const data = {
          "id":this.form.id
        }

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data){//获取到该设备信息
                var object = obj.data;
                this.form.equip_udi = object.udi;
                this.form.hospital_name = object.hospitalName;
                this.form.provinceCode = object.provinceCode;
                this.form.cityCode = object.cityCode;
                if(this.form.provinceCode){
                  areaSingleConversionUtil.codeToName(this.form)
                }
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getSelectedList(val){
        this.form.provinceCode = val[0];
        this.form.cityCode = val[0] + val[1]

        areaSingleConversionUtil.codeToName(this.form)
      },
      resetForm() {
        // this.$refs[formName].resetFields();
        this.form.provinceCode = ''
        this.form.provinceName = ''
        this.form.cityCode = ''
        this.form.cityName = ''
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.editOneEquipment();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      editOneEquipment(){
        if(this.form.equip_udi.length == 49){
        }else{
          this.$message({
            message:'UDI不合规，请确认后再提交',
            type:'warning'
          })
          return;
        }

        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/update';
        const data = {
                "id":this.form.id,
                "udi":this.form.equip_udi,
                "hospitalName":this.form.hospital_name,
                "provinceCode":this.form.provinceCode,
                "cityCode":this.form.cityCode,
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                type:'success',
                message:'修改成功'
              })
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
    },
    mounted() {
      this.getEquipDetail();

      this.placeList = this.$place.province;
    },
    created() {
      this.form.id = this.$route.query.id;
    }
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }

    .equip-add{
      width: 100%;
      float: left;

      .add-form{
        padding: 25px 5px;

          .distinguish{
            display: flex;
            flex-direction: row;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }

          // .warning-handle{
          //   background-color: #B26100;
          //   border: 1px solid rgba(255, 132, 0, 0.84);
          //   // border-radius: 20px;
          //   color: #fff;
          //   margin-left: 5px;
          // }

          .warning-handle{
            // float: right;
            background-color: #B26100;
            border: 1px solid rgba(255, 132, 0, 0.84);
            // border-radius: 20px;
            color: #fff;
            margin-left: 5px;
            // margin-top: -15px;
          }

          .error{
          }
      }
    }


  }

</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-edit.vue